var conditionals = document.querySelectorAll('form [data-form-conditional]');

conditionals.forEach((conditional) => {
    const form = conditional.closest('form');

    function toggleInputs(conditional, isActive) {
        conditional.querySelectorAll('input, select, textarea').forEach((input) => {
            input.disabled = !isActive;

            if (isActive) {
                input.removeAttribute('tabindex');
            } else {
                input.tabIndex = -1;
            }
        });
    }

    let [name, values] = conditional.dataset.if.split(':'),
        input = form.elements[name];

    values = values.split(',');

    if (input instanceof RadioNodeList || input instanceof HTMLCollection) {
        input.forEach((_input) => {
            if (_input.type === 'radio') {
                _input.addEventListener('change', () => {
                    if (values.includes(_input.value)) {
                        conditional.classList.add('is-active');
                    } else {
                        conditional.classList.remove('is-active');
                    }

                    toggleInputs(conditional, values.includes(_input.value));
                });

                if (values.includes(_input.value) && _input.checked) {
                    conditional.classList.add('is-active');
                    toggleInputs(conditional, true);
                } else {
                    toggleInputs(conditional, false);
                }
            } else {
                _input.addEventListener('change', () => {
                    if (values.includes(_input.value)) {
                        if (_input.checked) {
                            conditional.classList.add('is-active');
                        } else {
                            conditional.classList.remove('is-active');
                        }
                        toggleInputs(conditional, _input.checked);
                    }
                });

                if (values.includes(_input.value) && _input.checked) {
                    conditional.classList.add('is-active');
                    toggleInputs(conditional, true);
                } else {
                    toggleInputs(conditional, false);
                }
            }
        });
    } else if (input.tagName === 'SELECT') {
        input.addEventListener('change', () => {
            if (values.includes(input.value)) {
                conditional.classList.add('is-active');
            } else {
                conditional.classList.remove('is-active');
            }
            toggleInputs(conditional, values.includes(input.value));
        });

        if (values.includes(input.value)) {
            conditional.classList.toggle('is-active');
            toggleInputs(conditional, true);
        } else {
            toggleInputs(conditional, false);
        }
    } else {
        input.addEventListener('input', () => {
            if (values.includes(input.value)) {
                conditional.classList.add('is-active');
            } else {
                conditional.classList.remove('is-active');
            }
            toggleInputs(conditional, values.includes(input.value));
        });

        if (values.includes(input.value)) {
            conditional.classList.add('is-active');
            toggleInputs(conditional, true);
        } else {
            toggleInputs(conditional, false);
        }
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/lib/form/conditionals.js